<template>
  <div v-if="showVideoPlayer">
    <div class="inner">
      <video-player @ready="ready" :options="playerOptions" />
      <i class="el-icon-close" @click.stop="$emit('close-video-player')" />
    </div>
    <div class="mask" @click.stop="$emit('close-video-player')" ></div>
  </div>
</template>

<script>
import "video.js/dist/video-js.css";
import { videoPlayer as VideoPlayer } from "vue-video-player";

export default {
  props: {
    showVideoPlayer: {
      type: Boolean,
      default: false
    },
    videoSrc: String
  },
  computed: {
    playerOptions() {
      const src = this.videoSrc;
      return {
        muted: false,
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: "video/mp4",
            src
          }
        ]
      };
    }
  },
  methods: {
    ready(e) {
      const [videoPlayer] = e.children_;
      if (videoPlayer != null) {
        if (videoPlayer.paused) {
          videoPlayer.play()
        }
        this.$emit('receive-video', videoPlayer)
      }
    }
  },
  components: {
    VideoPlayer
  }
};
</script>

<style lang="scss" scoped>
.inner {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 50%;
  height: 680px;
  margin: auto;
  background: #000;
  z-index: 2019;

  ::v-deep .video-player,
  ::v-deep .video-js {
    width: 100%;
    height: 100%;
  }

  ::v-deep .vjs-big-play-button {
    display: none;
  }

  ::v-deep .vjs-button > .vjs-icon-placeholder::before {
    line-height: 2;
  }

  .el-icon-close {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 40px;
    color: #009688;
    cursor: pointer;
  }
}

.mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 2018;
  cursor: default;
}
</style>
